import React from 'react';
export function Footer() {
  return <footer className="w-full bg-white border-t border-line py-14 px-4" data-id="element-75" data-mp="32wd2cf6gdjt0">
      <div className="max-w-4xl mx-auto text-center" data-id="element-76" data-mp="3ggaqtvj9sd5g">
        <div className="text-rose font-bold tracking-[0.18em] text-xs mb-3 uppercase" data-id="element-77" data-mp="3gh3ng3oilm9v">
          🌸 Aula Mater™
        </div>
        <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink mb-4 uppercase tracking-tight" data-id="element-78" data-mp="36oy0j8d4dv1j">
          Aula Mater
        </h3>
        <p className="text-ink-soft max-w-2xl mx-auto text-sm md:text-base leading-relaxed mb-8" data-id="element-79" data-mp="3ufjvbxy45itl">
          Herramientas reales para tu vida profesional. Contenido práctico para
          bajar la tensión del día laboral, comunicarte mejor y cuidar tu
          energía mientras trabajás.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-10 text-sm text-ink" data-id="element-80" data-mp="3qblvtm4vm600">
          <span className="flex items-center gap-2" data-id="element-81" data-mp="2a1jl9ej7c453">
            📧{' '}
            <span className="font-medium select-all" data-id="element-82" data-mp="2ezut5jpxs4ko">
              soporteaulamater@gmail.com
            </span>
          </span>
          <span className="hidden sm:inline text-line" data-id="element-83" data-mp="3lbdbmpwng3k8">|</span>
          <span className="flex items-center gap-2" data-id="element-84" data-mp="3gc0ftfnsvm5i">
            📲 Instagram:{' '}
            <span className="font-medium select-all" data-id="element-85" data-mp="3v8rflq1dyzvn">@aulamater_</span>
          </span>
          <span className="hidden sm:inline text-line" data-id="element-86" data-mp="3q8div458jccx">|</span>
          <span className="flex items-center gap-2" data-id="element-87" data-mp="3qazo2x4nlfrz">
            📘 Facebook:{' '}
            <span className="font-medium select-all" data-id="element-88" data-mp="80xk4905f1jm">Aula Mater</span>
          </span>
        </div>

        <div className="border-t border-line pt-6 text-xs text-muted leading-relaxed max-w-2xl mx-auto" data-id="element-89" data-mp="31uo1e25c5ns">
          © {new Date().getFullYear()} Aula Mater™ — Todos los derechos
          reservados. Prohibida la reproducción y redistribución sin
          autorización expresa. Este material tiene fines informativos y de
          bienestar personal. No reemplaza el diagnóstico ni el tratamiento
          profesional.
        </div>
        <div className="font-serif-italic text-rose text-base mt-6" data-id="element-90" data-mp="tvmr3jy8gkmy">
          🌿 "Tu trabajo ocupa muchas horas de tu vida. No necesita ocupar
          también toda tu cabeza."
        </div>
      </div>
    </footer>;
}